export const tagsReport = [
    {
        seq: 1,
        ref: "F4DS5TR",
        tag_name: "Free",
        content_type: "Privilege",
        content_name: "บัตรเข้าชมภาพยนต์ที่ SF ฟรี",
        latest_update: "2021-07-23 17:05:04",
      },
      {
        seq: 2,
        ref: "D5RF6GY",
        tag_name: "Behavior",
        content_type: "Survey",
        content_name: "พฤติกรรมอะไรที่ทำให้พนักงานถึงเป็นออฟฟิศซินโดรม",
        latest_update: "2021-07-23 17:05:04",
      },
      {
        seq: 3,
        ref: "CS1F4DS",
        tag_name: "Interest",
        content_type: "Banner",
        content_name: "ระหว่างเที่ยว หรือ นอนอยู่เฉยๆ คุณอยากทำอะไรมากกว่ากัน ?",
        latest_update: "2021-07-23 17:05:04",
      },
      {
        seq: 4,
        ref: "RT5VF8O",
        tag_name: "Food",
        content_type: "Identity",
        content_name: "คุณแจ็ค ฮิทเดิล",
        latest_update: "2021-07-23 17:05:04",
      },
      {
        seq: 5,
        ref: "DEF23GT",
        tag_name: "Travel",
        content_type: "",
        content_name: "",
        latest_update: "2021-07-23 17:05:04",
      },
]